/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionareFormModel } from '../../models/questionare-form-model';

export interface QuestionareFormIdGet$Params {
  formId: string;
}

export function questionareFormIdGet(http: HttpClient, rootUrl: string, params: QuestionareFormIdGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<QuestionareFormModel>> {
  const rb = new RequestBuilder(rootUrl, questionareFormIdGet.PATH, 'get');
  if (params) {
    rb.path('formId', params.formId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PathologyStrictHttpResponse<QuestionareFormModel>;
    })
  );
}

questionareFormIdGet.PATH = '/Questionare/{formId}';
